import {createEntityService} from 'utils/createEntityService';
import {Program} from 'types/program';

export const BaseProgramService = createEntityService<Program>({
  baseUrl: 'api/v1/programs',
  entityName: 'program',
});

export class ProgramService extends BaseProgramService {}
